import { IsBoolean } from "class-validator";

export class AdminUpdateAssessmentStatusResult {
    @IsBoolean()
    success: boolean;
}